import { OrderDetails } from "../../../stores/slices/cartSlice";

export const getNewPackageId = (orderDetails?: OrderDetails): string => {
  return orderDetails?.orderNumber || "new";
};
